import Preloader from '../../components/Preloader';
import { Suspense, lazy } from "react";
// 1. Import useLocation from react-router-dom
import { useLocation } from 'react-router-dom';

// This assumes your Preview component is the default export from '../../pages/preview'
const Preview = lazy(() => import('../../pages/preview'));
const UltraEchoPublicReport = lazy(() => import('../../pages/ultra-echo-public'));

const About = lazy(() => import("../../pages/About"));
const Counter = lazy(() => import('../../pages/Counter'));
const SignUp = lazy(() => import('../../pages/SignUp'));
const VerifyEmail = lazy(() => import('../../pages/VerifyEmail'));
const PrivacyPolicy = lazy(() => import('../../pages/PrivacyPolicy'));
const RequestDeleteDetail = lazy(() => import('../../pages/RequestDeleteDetail'));

// 2. Create the wrapper component right here in this file
const PreviewPageWrapper = () => {
  const location = useLocation();
  // Safely access the data from the navigation state
  const reportData = location.state?.data || null;

  // Pass the extracted data as a prop to the actual Preview component
  return <Preview data={reportData} />;
}


const PublicPaths = [
  {
    path: "/about",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <About />
      </Suspense>
    ),
  },
  {
    path: "/counter",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Counter />
      </Suspense>
    ),
  },
  {
    path: "/sign-up",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <SignUp />
      </Suspense>
    ),
  },
  {
    path: "/verify-email/:token",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <VerifyEmail />
      </Suspense>
    ),
  },
  {
    path: "/preview",
    // 3. Use the wrapper component in the route definition
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PreviewPageWrapper />
      </Suspense>
    ),
  },
  {
    path: "/ultra-echo/:reportId",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <UltraEchoPublicReport />
      </Suspense>
    ),
  },
  {
    path: "/privacy-policy",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: "/delete-request",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <RequestDeleteDetail />
      </Suspense>
    ),
  },
];

export default PublicPaths;